import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const TopBar = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full flex justify-between items-center px-4 py-4 bg-heroBg shadow-md">
      {/* Back button on the left */}
      <Link to="/" className="text-[#041c16] font-semibold hover:text-gold transition z-50">
        AstroTrader
      </Link>

      {/* Menu icon on the right */}
      <button onClick={() => setOpen(!open)} className="text-[#041c16] z-50">
        {open ? <X size={28} /> : <Menu size={28} />}
      </button>

      {/* Dropdown menu */}
      {open && (
        <div className="absolute top-16 right-4 bg-white shadow-lg border border-gold rounded-lg py-2 px-4 z-40 w-40">
          <Link to="/" className="block py-2 text-[#041c16] hover:text-gold" onClick={() => setOpen(false)}>Home</Link>
          <Link to="/stars" className="block py-2 text-[#041c16] hover:text-gold" onClick={() => setOpen(false)}>Stars</Link>
          <Link to="/thoughts" className="block py-2 text-[#041c16] hover:text-gold" onClick={() => setOpen(false)}>Thoughts</Link>
          <Link to="/about" className="block py-2 text-[#041c16] hover:text-gold" onClick={() => setOpen(false)}>About</Link>
          <Link to="/login" className="block py-2 text-[#041c16] hover:text-gold" onClick={() => setOpen(false)}>Join Now</Link>
        </div>
      )}
    </div>
  );
};

export default TopBar;
